import { TEST_PREVIEW } from "../actions/types";
import { PREVIEW_PROGRESS } from "../actions/constants";

const initialState = {
  time: 0,
  error: null,
  taskIndex: 0,
  loading: false,
  progress: null,
  testDetails: null,
  testResults: null,
  isScreener: null,
  screenerSetId: null,
  screenerDraftId: null,
  screenerResponseId: null,
  lang: null,
  countries: [],
  // skipToTask: false,
};

const isSkipTrue = JSON.parse(localStorage.getItem("previewSkip"));

const testpreviewReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TEST_PREVIEW.LOAD:
      return {
        ...initialState,
        testDetails: payload,
        progress: isSkipTrue ? PREVIEW_PROGRESS.TASK_DETAILS : PREVIEW_PROGRESS.SCREENER,
        loading: false,
      };

    case TEST_PREVIEW.UPDATE:
      return { ...state, ...payload };

    case TEST_PREVIEW.ERROR:
      return { ...state, error: payload, loading: false };

    default:
      return state;
  }
};

export default testpreviewReducer;
